import { Instagram, Linkedin } from "lucide-react";

const cls = "w-11 h-11 flex items-center justify-center border hairline text-[var(--bone)] hover:text-[var(--ember)] hover:border-[var(--ember)] transition-colors duration-500";

export default function SocialLinks() {
  return (
    <div className="flex items-center gap-3">
      <a href="https://www.instagram.com/sergio__mancinelli/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={cls}>
        <Instagram size={18}/>
      </a>
      <a href="https://www.linkedin.com/in/sergiomancinelliillustrator/?locale=en" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className={cls}>
        <Linkedin size={18}/>
      </a>
      <a href="https://www.imdb.com/it/name/nm3644585/" target="_blank" rel="noopener noreferrer" aria-label="IMDb" className={`${cls} px-4 w-auto font-bold tracking-wider text-xs`}>
        IMDb
      </a>
    </div>
  );
}
